import { styled, Theme } from '@mui/material/styles';
import { Checkbox, Switch, Radio } from '@mui/material';

const baseCheckboxRadioStyles = ({ theme }: { theme: Theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.error.main,
  },
  '&.MuiCheckbox-indeterminate': {
    color: theme.palette.error.main,
  },
  padding: 0,
  width: '10.14px !important',
  height: '10.14px !important',
  marginLeft: '15px',
  marginRight: '12px',
  '& .MuiSvgIcon-root': {
    fontSize: '15px',
    width: '16px',
    height: '16px',
    fill: 'currentColor',
    padding: 0,
  },
});

export const StyledCheckbox = styled(Checkbox)(baseCheckboxRadioStyles);

export const StyledRadioCheckbox = styled(Radio)(baseCheckboxRadioStyles);

export const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '& .MuiSwitch-thumb': {
      color: '#A1A1A1',
      backgroundColor: '#A1A1A1',
    },
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      '& .MuiSwitch-thumb': {
        backgroundColor: '#E81C0E !important',
        color: 'red !important',
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#DFDFDF',
        ...theme.applyStyles('dark', {
          backgroundColor: '#DFDFDF',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
  },
}));
